/**
 * SCRUM-92 (DS-008-9) — amend-ownership-share.schema.ts
 *
 * Zod schema for PATCH /organizations/:slug/properties/:propertyId/ownership/:ownershipId/share
 * request body (endpoint #4).
 *
 * Accepts any integer 1–100; Lite mode enforces share=100 at the UC layer.
 */
import { z } from 'zod';
export const amendOwnershipShareSchema = z.object({
    newShare: z.number().int().min(1).max(100),
});
//# sourceMappingURL=amend-ownership-share.schema.js.map